module.exports = __webpack_public_path__ + "img/Componente 44 – 1.986c937b.svg";